export default __webpack_public_path__ + "static/media/YAS0240.34I-27722_-16637_0.ecad6790.jpg";